import React from 'react';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import FeatureCard from './FeatureCard';
import SectionIntro from '../../../molecules/SectionIntro';

const HomeWhatWeDo = () => {
  const { t } = useTranslation('common');
  return (
    <section className="bg-white py-16 md:py-24">
      <div id="features-container">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-5xl lg:px-8">
          <SectionIntro
            title={t('service.home.whatWeDo.title')}
            intro={t('service.home.whatWeDo.intro')}
          />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8 pb-8">
            <FeatureCard
              featureName="oneToOne"
              title={t('service.home.whatWeDo.oneToOne.title')}
              intro={t('service.home.whatWeDo.oneToOne.intro')}
            />
            <FeatureCard
              featureName="fitSchedule"
              title={t('service.home.whatWeDo.fitSchedule.title')}
              intro={t('service.home.whatWeDo.fitSchedule.intro')}
            />
            <FeatureCard
              featureName="affordable"
              title={t('service.home.whatWeDo.affordable.title')}
              intro={t('service.home.whatWeDo.affordable.intro')}
            />
            <FeatureCard
              featureName="certifiedTutors"
              title={t('service.home.whatWeDo.handPicked.title')}
              intro={t('service.home.whatWeDo.handPicked.intro')}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default HomeWhatWeDo;
